import React, { Children } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';

import { BlogPost } from 'Components/wordpress/blog/BlogPost';

import { BlogPost as BlogPostType, WordpressData, WordpressRouteParams } from '../../@types/Wordpress';
import { EmptyContent } from '../EmptyContent/EmptyContent';

import styles from '../../WordpressPages.scss';

export type BlogContentProps = {
  data: WordpressData | null;
  isSSR: boolean;
};

export const BlogContent: React.FC<BlogContentProps> = ({ data, isSSR }) => {
  const params = useParams<WordpressRouteParams>();
  const match = useRouteMatch();

  if (!data?.posts?.length) {
    return <EmptyContent message="No posts to show." />;
  }

  const blogURL = match.url?.split('/')[1];

  return Children.toArray(
    (data.posts as BlogPostType[]).map((post: BlogPostType, index: number) => {
      const { author, content, date, excerpt, slug, title } = post;
      return (
        <BlogPost
          key={slug ?? title}
          {...{ date, slug, title }}
          author={{ name: author.name }}
          className={index === 0 && !data?.hasPageTitle ? styles.noTopMargin : undefined}
          content={
            (isSSR && data.showFull) || (!isSSR && params.post) ? content : excerpt
          }
          noLink={!!params.post}
          wordpressContent={{
            className: `${styles.wordpressContent} ${styles.wordpressContent}_content_${blogURL}`,
          }}
        />
      );
    }),
  );
};
